module.exports = __webpack_public_path__ + "img/xpddd.a8201103.png";